export class TextConverterToJsonResponseDto {
  json: any;
  title: string;
}